export default "__VITE_ASSET__C$IDlGTl__"